import type { Measurement } from "./form-state";
import type { ShiftProductionFormPayload } from "../../../shared/shift-production-form/contracts";

export function resolveMissingMeasurementUnits(
  payload: ShiftProductionFormPayload,
  speedUnit: string | null,
) {
  return {
    ...payload,
    products: payload.products.map((product) => ({
      ...product,
      measurements: product.measurements.map((measurement) =>
        measurement.state === "MEASURED" && !measurement.unit
          ? {
              ...measurement,
              unit: measurementUnit(measurement.key, speedUnit),
            }
          : measurement,
      ),
    })),
  };
}

const fixedUnits: Partial<Record<Measurement["key"], string>> = {
  MACHINE_TEMPERATURE: "°C",
  OVEN_TEMPERATURE: "°C",
  MOLD_TEMPERATURE: "°C",
  TUNNEL_TEMPERATURE: "°C",
  UNIT_WEIGHT: "g/adet",
  PRODUCT_MOISTURE: "%",
  AMBIENT_TEMPERATURE: "°C",
  AMBIENT_HUMIDITY: "% bağıl nem",
};

export function measurementUnit(
  key: Measurement["key"],
  speedUnit: string | null | undefined,
) {
  if (key === "THEORETICAL_LINE_SPEED" || key === "ACTUAL_LINE_SPEED")
    return speedUnit?.trim() || null;
  return fixedUnits[key] ?? null;
}

export function withMeasurementValue(
  measurement: Measurement,
  value: number | null,
  speedUnit?: string | null,
): Measurement {
  if (value === null)
    return {
      ...measurement,
      state: null,
      value: null,
      unit: null,
      measuredAt: null,
      pointOrMethod: null,
      missingReason: null,
      explanation: null,
    };
  return {
    ...measurement,
    state: "MEASURED",
    value,
    unit: measurementUnit(measurement.key, speedUnit),
    missingReason: null,
    explanation: null,
  };
}

export function withMeasurementException(
  measurement: Measurement,
  state: "NOT_MEASURED" | "NOT_APPLICABLE",
): Measurement {
  return {
    ...measurement,
    state,
    value: null,
    unit: null,
    measuredAt: null,
    pointOrMethod: null,
    missingReason: state === "NOT_MEASURED" ? measurement.missingReason : null,
    explanation: state === "NOT_MEASURED" ? measurement.explanation : null,
  };
}
